






















































































































import Vue from "vue";
import { Component } from "nuxt-property-decorator";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import BaseInput from "~/components/core/BaseInput.vue";
import BaseCheckbox from "~/components/core/BaseCheckbox.vue";
import ResponsiveImg from "~/components/core/ResponsiveImg.vue";

@Component({
  name: "RegisterPage",
  components: { BaseInput, BaseCheckbox, ResponsiveImg },
  middleware: ["refreshToken", "notAuthenticated"],
})
export default class Registration extends Vue {
  email: string | null = null;
  password: string | null = null;
  errorMessage: string | null = null;
  emailInvalid = true;
  passwordInvalid = true;
  isLoading = false;
  agree = false;
  agreeInvalid = true;
  agreeCommercial = false;

  get invalid() {
    return (
      this.emailInvalid ||
      this.passwordInvalid ||
      (this.agreeInvalid && !this.agreeCommercial)
    );
  }

  get faTimes() {
    return faTimes;
  }

  async onSubmit() {
    if (!this.email || !this.password) {
      return;
    }

    this.isLoading = true;

    this.errorMessage = await this.$store.dispatch("signUp", {
      email: this.email,
      password: this.password,
    });

    if (this.errorMessage) {
      this.isLoading = false;
      return;
    }

    this.$router.push(
      "/auth/confirm/registration/" +
        this.email +
        "?agreeCommercial=" +
        this.agreeCommercial +
        "&template=" +
        this.$route.query.template
    );

    this.isLoading = false;
  }
}
